import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FeatherIconsComponent } from './components/feather-icons/feather-icons.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { ToggleFullscreenDirective } from './directives/fullscreen.directive';
import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';
import { NavService } from './service/nav.service';
import { WINDOW_PROVIDERS } from './service/windows.service';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ModalEmailComponent } from './components/modal-email/modal-email.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FileSizePipe } from './pipes/file-size.pipe';
import { InlineEditComponent } from './components/inline-edit/inline-edit.component';
import { InvitationOptionsComponent } from './components/invitation-options-component/invitation-options.component';
import { HomepageComponent } from './components/homepage/homepage.component';
import {HomepageComponentAfter} from "./components/homepage/homepage_after.component";
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ModalContractCancelComponent} from "./components/modal-contract-cancel/modal-contract-cancel.component";

@NgModule({
  declarations: [
    ToggleFullscreenDirective,
    FeatherIconsComponent,
    FooterComponent,
    HeaderComponent,
    SidebarComponent,
    ContentLayoutComponent,
    BreadcrumbComponent,
    ModalEmailComponent,
    ModalContractCancelComponent,
    InlineEditComponent,
    InvitationOptionsComponent,
    FileSizePipe,
    HomepageComponent,
    HomepageComponentAfter
  ],
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        NgbModule
    ],
  providers: [NavService, WINDOW_PROVIDERS, DatePipe],
  exports: [FeatherIconsComponent, ToggleFullscreenDirective, FileSizePipe, HomepageComponent, HomepageComponentAfter]
})
export class SharedModule { }
